import camelcase from 'camelcase';

const logos = require.context('./images/logos', true);

const exportEnv = {
  apiHost: null,
  reportsHost: null,
  baseRoute: null,
  mainColor: null,
};

Object.keys(process.env).forEach((key) => {
  if (key.indexOf('REACT_APP_') === -1) {
    return;
  }
  const mappedKeyName = camelcase(key.replace('REACT_APP_', ''));
  exportEnv[mappedKeyName] = process.env[key];
});

// build image paths
exportEnv.loginLogo = logos(`./${exportEnv.loginLogo}`).default;
exportEnv.colors = [exportEnv.primary, exportEnv.secondary, exportEnv.tertiary];

export default exportEnv;
